// @ts-nocheck
import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ASSETS } from '../../../assets/assets';

@Component({
  selector: 'lbca-body-feedback',
  templateUrl: './body-feedback.component.html',
  styleUrl: './body-feedback.component.scss',
  imports: [NgTemplateOutlet],
})
export class BodyFeedbackComponent implements OnInit {
  readonly assets = inject(ASSETS);
  public fieldsLabels: any = {};

  public type: any = 'col';
  public place: 'module' | 'body' = 'module';
  public feedback: 'notfound' | 'searching' | 'caixavazia' | 'noFiles' | 'noLegalrequests' =
    'notfound';

  @Input('type')
  set setType(feedbackType: any) {
    this.type = feedbackType;
  }

  @Input('place')
  set setPlace(local: 'module' | 'body') {
    this.place = local;
  }

  @Input('feedbackIcon')
  set setFeedbackIcon(
    local: 'notfound' | 'searching' | 'caixavazia' | 'noFiles' | 'noLegalrequests'
  ) {
    this.feedback = local;
  }

  ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
  }
}
